<template>
  <div id="center" class="clearfix" style="min-height: 246px">
    <div id="left-menu" class="pull-left">
      <i class="iconfont m-show-btn mhide"></i>

      <div class="menu-wrap">
        <i class="iconfont close-leftmenu-btns mhide"></i>
        <div class="t-user t-teacher-box">
            <img
            :src="this.$store.state.headPortrait"
            onerror="this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAE90lEQVRogdWbTWgdVRTHf3PfVxbWCFahRoTulFJELRVLrc8aFy5trYW6luLHtttSu5SCC7Eu3IpiStuVaBfamlaCUkF4dmtBqmIwJa2FfMybuS5O7nSSzJt5M/fMS/KDLPLevHPPf+73OfcGCwsL1MQ48AKwB9gF7AQmgIeAB1aeuQfMA38BvwM3gOvADHCnDqcCZcGPA0eBQ8DzQKOinQj4CbgAnAP+UPEOPcEHgBPAa1QXOYgI+AY4A/zga8xXcBc4Dbzo68iQXAVOAleqGjAVf7cD+By4zOjEslLW5ZWyd1QxUKWGjwCfIYPSRnIHeBvp40NTpobbwMfAFBsvFsSHKcSnzrA/GraGtwEXgVcquVY/08DrwO2iB4ep4UeQfrNZxYLMEt8jvuZSJHgc+BZ4TsGpunkauERBd8sT3EYm/mcVnaqbZxCf24MeyBP8EXBQ26MRcBDxPZNBg9YRZATcyhwlQ0OW4AngN2SRr0Icx8mftRZrrRQeBAAYYwiCgEajkXymwDywG7iV/jBL8AVkiC9NFEWJKEda4DAYY2g0GjQaKkvyi8hGJmGt4JeR4b0Si4uLVX+6DmMMrVZLo8Ynge8Su2u+PO1jWbE5Escxy8vLpVrHAE6l/0kLPgDs97GsKRikOyiI3o9oA1YLPuFjNQxD4jj2MZGJtZZ+v+9rJtHm+vCjwJ9As4o11/zqpNPp+LSgPjL7zLoaPkZFsUAtNatcRhPRmDTpw74O1Y3CSz0M0qTHgTk8YlFhGBJFka9DuRhjaLcHLpGHIQIeNsA+PANv2qNzTWU0gH2GLbIbUnqpewyy3vRii9QwwC6DZAS82EKCdxrgMV8rCsu/QpSmvgmD5zYwjmPCMNRwJpd+v68h+kHD/cTWpkehJW2rmnnYEBT68bJBUpYb6cQouWeQUEhlRinYGO8G+Z9BktEb7cioyvjHADd9rTSbzVprOggCms3Km7k0Nw0SofTCGEOn06mlppVt3zDALxqWAK1I4yqUX+J1le1hmqWlJdWVl2ekI00EbDdIYnlGwyJAq9XSMqUVpnXMAPOuvZzXsuo26r6ONptN7S5yHpSCeFlYa4miqHTE0Y3IymLXBfFmkdyqGs7xsbGxoWs7CAI6nU4dg98lROOquPSH2qVsIhJtacHTwLU6SitTwzVwDdEGrM8tndIsyVpbKiPh9tbKce4P0v+opksdURQlqdOquHyxZ864MF0KckC0R8lISBzHiVBtXM7YJc6HJDMhnjUN3QKOA1/lWUsnv+tOtbjTAyA1b4xJXkIOx1kjFvIPpp0F3kl/4ObWKIpGErgrwjX7jJ3Up8C7mb/JEdxG5q8u3B9QNoPQtQRBQKvVchuNaeBVIDOdmbcVWQbeAHqK2fhacInzOI57yCA1MHdbtPeas9ZOhmH4q6qH9dALw3DSWjuX91DhZrPf789aa19CzltuVq4CXWvtbNHaPVewG6SAu8jx/k+0PFTkLNJnbwOFA2qu4DXTzRLwPvAmNd04KcldxJf3EN8S8qbJMoId54CngC/KeqjIl8CTDDgNry0Y4G/gLeQgWy0bjgH8iBwePbbiQyaVBQ8xDV1BLl50ga+BOpZc8YrtLnLmqnDwzPM79wpAhYDcE0i/OgTsxe+i1s/IRmaKkhe1XCAh87s8wS5EU3HBkb6KtxtJvG8n+yrev0hCoIfnVbyiENH/d4LwXx+Ezr4AAAAASUVORK5CYII='"
            width="36"
            height="36"
          /><span
            class="center-name"
            >{{this.$store.state.userName}}</span
          >
          <!--../assets/image/user.png-->
          <!-- <span class="center-auth auth-2">未认证</span> -->
        </div>
        <ul class="my-left">
          <li class="m-li1">
            <i class="iconfont icon-wode"></i
            ><router-link to="/teachersPersonalCenter">我的信息</router-link>
          </li>
          <li class="m-li2 cur">
            <i class="iconfont icon-chugui2"></i>
            <router-link to="/personalCenterChangePasswords">修改密码</router-link>
          </li>
          <li class="m-li3">
            <i class="iconfont icon-star-hollow"></i>
            <router-link to="/myCollection">我的收藏</router-link>
          </li>

          <li class="m-li4">
            <i class="iconfont icon-555"></i>

            <router-link to="/myComments">我的评论</router-link>
          </li>

          <li class="m-li8">
            <i class="iconfont icon-555"></i>

            <router-link to="/myExperiment">我的实验</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div id="content" class="pull-right">
      <div class="center_content" style="min-height: 533.6px">
        <div class="container">
          <form id="itemForm">
            <div class="item">
              <span class="title long">旧密码</span>
              <input
                type="password"
                v-model="changeThePasswordRequest.oldPassword"
                name="oldPassword"
                class="t-input"
              />
            </div>
            <div class="item">
              <span class="title long">新密码</span>
              <input
                type="password"
                v-model="changeThePasswordRequest.newPassword"
                name="password"
                class="t-input"
              />
            </div>
            <div class="item">
              <span class="title">确认新密码</span>
              <input
                type="password"
                name="password2"
                id="imgurl"
                class="t-input"
                v-model="changeThePasswordRequest.checkPass"
                @change="enterThePassword(changeThePasswordRequest.checkPass)"
              />
            </div>
          </form>
          <span class="submitBtn" @click="commitChanges()">提交</span>
          <div class="tip">
            <p>1、密码长度6-15位</p>
            <!-- <p>2、须同时包含大写字母、小写字母、数字、特殊字符中的任意三种</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import {
  personalInformationQuery,
  afterTheLoginAccessPermissions,
  loginAccessToTheMenu,
  changeThePassword,
} from "../assets/api/index";
import router from "../router/index.js";
import { ElMessage } from "element-plus";
export default {
  setup() {
    const tableData = ref([]);
    const theLoginRequest = reactive({
      userId: null,
    });
    const getStatusInformation = reactive([]);
    const provincialData = ref([]);
    const getData = () => {
      personalInformationQuery(theLoginRequest).then((res) => {
        tableData.value = res.data;
        provincialData.value = JSON.parse(res.data.remark);

        getStatusInformation.value = JSON.parse(res.data.remark).indexType;
      });
    };

    //登陆后获取权限
    const afterLandingPermissionData = ref();
    const automaticallyAccessPermissions = () => {
      afterTheLoginAccessPermissions().then((res) => {
        afterLandingPermissionData.value = res.user;
        theLoginRequest.userId = res.user.userId;
        getData();
      });
    };
    automaticallyAccessPermissions();

    //登陆后获取菜单

    const automaticAccessToTheMenu = () => {
      loginAccessToTheMenu().then((res) => {});
    };
    automaticAccessToTheMenu();

    //上传图片
    const handleRemove = (file, fileList) => {
      console.log(file, fileList);
    };

    //修改密码
    const changeThePasswordRequest = reactive({
      oldPassword: null,
      newPassword: null,
      checkPass: null,
    });

    const enterThePassword = (value) => {
      if (value == changeThePasswordRequest.newPassword) {
      } else {
        changeThePasswordRequest.checkPass = "";
        ElMessage.error("两次密码输入不一致！");
      }
    };
    const commitChanges = () => {
      if (changeThePasswordRequest.oldPassword == null) {
        ElMessage.info("请输入旧密码");
      } else if (changeThePasswordRequest.newPassword == null) {
        ElMessage.info("请输入新密码");
      } else if (changeThePasswordRequest.checkPass == null) {
        ElMessage.info("请输入确认密码");
      } else {
        changeThePassword(changeThePasswordRequest).then((res) => {
          if (res.code == 500) {
            ElMessage.error(res.msg);
          } else {
            ElMessage.success(res.msg);
          }
        });
      }
    };

    const gender = (sex) => {
      if (sex == 0) {
        return "男";
      } else {
        return "女";
      }
    };

    //默认图显示
    const imageIsEmpty = (value) => {
      if (value == null || value == "") {
        return require("../assets/image/index.png");
      } else {
        return value;
      }
    };

    return {
      imageIsEmpty,
      tableData,
      afterLandingPermissionData,
      getStatusInformation,
      provincialData,
      changeThePasswordRequest,
      enterThePassword,
      commitChanges,
      handleRemove,
      gender,
      automaticAccessToTheMenu,
      automaticallyAccessPermissions,
      getData,
    };
  },

  name: "teachersPersonalCenter",
};
</script>

<style src="../assets/css/jiaoshi/bootstrap-v3.3.7.min.css" scoped></style>
<style src="../assets/css/jiaoshi/common.css" scoped></style>
<style src="../assets/css/jiaoshi/common1.css" scoped></style>
<style src="../assets/css/jiaoshi/form.css" scoped></style>
<style src="../assets/css/jiaoshi/laydate.css" scoped></style>
<style src="../assets/css/jiaoshi/my-profile.css" scoped></style>
<style src="../assets/css/jiaoshi/header_v5.css" scoped></style>
<style src="../assets/css/jiaoshi/change-password.css" scoped></style>

<style scoped></style>